import { supabase } from '../supabase/client';

export const checkIsAdmin = async userId => {
  const { data, error } = await supabase.from('user_admin').select('*').eq('id', userId).single();

  if (error) {
    return false;
  }

  return data?.is_admin || false;
};

export const getDashboardCounts = async () => {
  // Get places count
  const { count: placesCount } = await supabase
    .from('places')
    .select('*', { count: 'exact', head: true });

  // Get events count
  const { count: eventsCount } = await supabase
    .from('events')
    .select('*', { count: 'exact', head: true });

  // Get tours count
  const { count: toursCount } = await supabase
    .from('tours')
    .select('*', { count: 'exact', head: true });

  return {
    places: placesCount || 0,
    events: eventsCount || 0,
    tours: toursCount || 0,
  };
};
